// extracted by mini-css-extract-plugin
module.exports = {"container":"cookie-banner-module--container--24W-y"};